import { Checkbox } from './Checkbox';

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/Checkbox/index.js